import { Modal } from 'react-bootstrap'
import React, { useEffect } from 'react'
import styled from 'styled-components'

import { ConnectYourMailbox } from '../SignupMailbox/pages/ConnectYourMailbox'
import { useGetConfigurationsQuery } from '../../../redux/Api/SubscriptionsApi'
import { track } from '../../../global/eventTracking'

const Styled = styled.div`
  .modal-title {
    font-size: 22px;
    font-weight: bold;
    color: #404040;
    padding-left: 40px;
    margin: auto;
    text-transform: capitalize;
  }

  .modal-title svg {
    margin: auto;
    font-size: 28px;
    margin-bottom: 10px;
    margin-top: 5px;
  }

  .modal-header {
    padding-top: 10px;
    height: 85px;
    border-bottom: none;
  }

  .modal-header button {
    margin: 0 !important;
    margin-right: 20px !important;
    font-size: 10px;
    padding: 10px;
    border: 1px solid rgb(0, 0, 0, 0.5);
    border-radius: 50%;
  }
`

const ConsentModal = ({ show, onClose, onButtonClick, provider }) => {
  const [showModal, setShowModal] = React.useState(false)
  const { data: configuration } = useGetConfigurationsQuery()
  useEffect(() => {
    if (configuration) {
      if (configuration.isABTestingEnabled) {
        setShowModal(true)
        track('login_page_view_consent', { provider })
      } else {
        onButtonClick()
      }
    }
  }, [configuration])

  if (!showModal) {
    return null
  }

  return (
    <Modal show={show} centered={true} onHide={onClose} size={'lg'}>
      <Styled>
        <Modal.Header closeButton>
          <Modal.Title>Connect your Mailbox</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ConnectYourMailbox nextStep={onButtonClick} hideTitle />
        </Modal.Body>
      </Styled>
    </Modal>
  )
}

export default ConsentModal
